<template>
    <div>
        <img :src="profile" class="profile circle" v-if="profile">
        <div v-else class="profile-no-image" :style="`background-color:${backgroundColor};`">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * 회원 프로필 이미지 컴포넌트(member profile image Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['profile'],
    data() {
        return {
            arrBackgroundColors: ['#fc5356','#7d61d8','#4d9fd6','#40bca7','#9db82f','#df8830','#a967d4','#696481','#4c438d','#fe7947'],
            backgroundColor: '#fc5356'
        }
    },
    mounted() {
        this.backgroundColor = this.randomItem(this.arrBackgroundColors)
    },
    methods: {
        randomItem(a) {
            return a[Math.floor(Math.random() * a.length)]
        }
    }
}
</script>
